import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateInviteCode } from '@/services/auth/authService';
import { useToast } from "@/hooks/use-toast";

const InviteCode = () => {
  const [inviteCode, setInviteCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!inviteCode.trim()) {
      setError('Please enter a valid invite code');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      const existingInviteCode = localStorage.getItem('inviteCode');
      if (existingInviteCode) {
        navigate('/signup');
      }

      const isValid = await validateInviteCode(inviteCode.trim());
      
      if (isValid) {
        toast({
          title: "Success!",
          description: "Your invite code is valid. Redirecting to signup...",
        });
        
        // Short delay before redirecting
        setTimeout(() => {
          navigate('/signup');
        }, 1500);
      } else {
        setError('Invalid invite code. Please try again or contact Chris at chris@facultyofskin.com');
      }
    } catch (error) {
      console.error('Error validating invite code:', error);
      setError('An error occurred. Please try again later or contact Chris at chris@facultyofskin.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-brutal-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="brutal-card p-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-mono uppercase font-semibold text-brutal-black">Enter Invite Code</h2>
            <p className="text-brutal-charcoal mt-2 font-mono">Please enter your invite code to continue</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="inviteCode" className="block text-sm font-mono uppercase mb-2 text-brutal-black">
                Invite Code
              </label>
              <input 
                id="inviteCode"
                type="text" 
                value={inviteCode} 
                onChange={(e) => setInviteCode(e.target.value)} 
                required 
                className="brutal-input w-full"
                placeholder="Enter your invite code"
                disabled={isSubmitting}
              />
              {error && (
                <p className="mt-2 text-red-600 text-sm">{error}</p>
              )}
            </div>
            <div>
              <button 
                type="submit" 
                className="brutal-button w-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Validating..." : "Continue"}
              </button>
            </div>
          </form>
          
          <div className="mt-8 text-center">
            <p className="text-brutal-charcoal">
              Don't have an invite code?{" "}
              <a href="/join-waitlist" className="text-brutal-dark font-bold hover:underline">
                Join our waitlist
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteCode;
